import React from 'react'
import { useCookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';

interface AdminGuardProps {
    children: React.ReactNode;
}
const AdminGuard = ({ children }: AdminGuardProps) => {
    const [cookies, setCookie, removeCookie] = useCookies(['user-data', "token"]);
    if (cookies["token"] && cookies['user-data'].role == "admin") {
        return <>{children}</>
    }
    else {
        return <Navigate to='/login' />
    }
}

export default AdminGuard